/*
  Miért nem törölhető egy admin fiók: a mondatok egyetlen helye a kliensen.

  A jog elvétele EGY helyen történik, a Felhasználók lista admin-kapcsolóján
  (`revokeAdminAccess`, ami az utolsó admin jogát sem engedi elvenni); a törlés nem lehet egy
  második út ugyanoda. A szerver (`functions/src/lib/userAccounts.js`) a MÁSIK fiókra
  vonatkozó mondatot szó szerint ugyanígy adja vissza, és egy teszt
  (`functions/test/userAccounts.test.js`) őrzi, hogy a kettő ne csússzon szét.
*/

/** Egy MÁSIK személy admin fiókja: a Felhasználók lista törlése (és a szerver elutasítása). */
export const ADMIN_ACCOUNT_DELETE_BLOCKED =
  "Admin fiókot nem törölhetsz. Előbb vedd el az admin jogát a Felhasználók listában.";

/** A SAJÁT admin fiókod: a Profilom oldal törlés-kártyája és az `AuthContext.deleteAccount` őre. */
export const OWN_ADMIN_ACCOUNT_DELETE_BLOCKED =
  "Admin fiókot nem törölhetsz. Előbb egy másik admin vegye el a jogodat a Felhasználók listában.";
